import React, {useEffect, useMemo, useState} from "react";
import DeleteOrganizationModal from "../../components/organization/deleteOrganizationModal";
import { useWindowSize } from "../../../hook/useWindowSize";
import {
    useGetIhioBillCheck,
    useGetIhioBillList
} from "../../../hook/request/ihioPrescriptionFilling";
import PrescriptionFillingTrackingCodeCard
    from "../../components/ihioPrescriptionFilling/prescriptionFillingTrackingCodeCard";
import PrescriptionFillingTable from "../../components/ihioPrescriptionFilling/dataList/prescriptionFillingTable";
import momentJ from "moment-jalaali";
import {TGIdNameData} from "../../../types/general";
import {ALLERGY_SEVERITY, PersianMonthOption, PersianYearOption} from "../../../constants/constant/enum";
import SelectField from "../../components/general/form/selectField";
import {useForm} from "react-hook-form";
import Icon from "../../components/general/icon";
import PrescriptionBillCardsBox from "../../components/ihioPrescriptionBill/dataList/prescriptionBillCardsBox";


type IhioBillListType = {
    billId?: number;
    billType?: string;
    billTypeName?: string;
    billCycle?: string;
    description?: string;
    billInfo?: {
        productName?: string;
        specialAccount?: string;
        type?: TGIdNameData;
        count?: number;
        orgPart?: number;
    }[];
}

const IhioPrescriptionBillList = () => {

    const [width] = useWindowSize();
    const [filterValues, setFilterValues] = useState<{year: number, month: number}>({
        year: momentJ().jYear(),
        month: momentJ().jMonth()
    })
    const [ihioBillListData, setIhioBillListData] = useState<IhioBillListType[]>([])

    const {
        control,
        handleSubmit,
        reset,
        formState: {errors},
    } = useForm<{year: number, month: number}>({
        defaultValues: useMemo(() => filterValues, [filterValues]),
    });


    // services
    const getIhioBillCheckRequest = useGetIhioBillCheck();
    const getIhioBillListRequest = useGetIhioBillList()


    useEffect(() => {
        if(getIhioBillCheckRequest?.isSuccess && getIhioBillCheckRequest?.data?.data?.result?.billView) {
            getIhioBillListRequest?.mutate(filterValues);
        }
    }, [getIhioBillCheckRequest?.isSuccess]);

    useEffect(() => {
        if(getIhioBillListRequest?.data?.data?.result) {
            setIhioBillListData(getIhioBillListRequest?.data?.data?.result);
        }
    }, [getIhioBillListRequest?.data?.data?.result]);

    const openFilterDropDown = (param: any) => {
        if(param?.target?.value != null) {
            const {value, name} = param?.target
            console.log(value, name)
            setFilterValues({
                ...filterValues,
                [name]: value
            })
        }
    }


    return (
        <>
            <div className="card-box">
                <section className="filter-box d-flex flex-column flex-md-row mb-4">
                    <div className="d-flex align-items-center gap-3 form-group ms-md-auto">
                        <SelectField
                            options={PersianMonthOption}
                            control={control}
                            name="month"
                            placeholder='انتخاب کنید'
                            className="font-en"
                            onChange={(e) => openFilterDropDown(e)}
                        />
                        <SelectField
                            options={PersianYearOption}
                            control={control}
                            name="year"
                            placeholder='انتخاب کنید'
                            className="font-en"
                            onChange={(e) => openFilterDropDown(e)}
                        />
                        <button
                            onClick={() => getIhioBillListRequest?.mutate(filterValues)}
                            className="btn btn-primary rounded d-flex align-items-center fw-bold px-4 ms-2"
                        >
                            <span className="d-inline-flex font-25 ms-2 ps-2"><Icon name="filter"/></span>
                            اعمال فیلتر
                        </button>
                    </div>
                </section>

                <section className="table-cont table-responsive">
                    <PrescriptionBillCardsBox
                        dataList={ihioBillListData}
                        isRequesting={getIhioBillListRequest.isPending}
                    />
                </section>
            </div>

            <DeleteOrganizationModal />
        </>
    );
};

export default IhioPrescriptionBillList;